import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Well, Button } from 'react-bootstrap';
import renderField from '../../FormTemplate/InputControl';

class NewSubCategoryForm extends React.Component {

   constructor(props) {
      super(props);
      this.newSubCategoryCreate = this.newSubCategoryCreate.bind(this);
   }

   newSubCategoryCreate(inputs) {
      const { createNewSubCategory, shopId, categoryId } = this.props;
      return createNewSubCategory(inputs, shopId, categoryId);
   }

   render() {
      const { handleSubmit } = this.props; //eslint-disable-line react/prop-types
      return (<Well>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.newSubCategoryCreate)} >
               <Field name="name" component={renderField} type="text" placeholder="Sub Category Name"
                      label="Sub Category Name" />
               <Button type="submit" >Save</Button>
            </form>
         </Well>
      );
   }
}

NewSubCategoryForm.propTypes = {
   createNewSubCategory: PropTypes.func.isRequired,
   shopId: PropTypes.number.isRequired,
   categoryId: PropTypes.number.isRequired
};

export default reduxForm({
   form: 'newSubCategoryForm'
})(NewSubCategoryForm);



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/NewSubCategoryForm.js
 **/